module.exports = __webpack_public_path__ + "static/img/safe-bg.1eeafe7b.png";